define('plugin/product/model/ProductDeliveryModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    return BaseModel.extend({

        url: '/ext/product/delivery',

        defaults: {
            id: null,
            info: null
        }

    });

});
